// extracted by mini-css-extract-plugin
module.exports = {"middleBox":"Page500_middleBox__2G52c"};